export default "__VITE_ASSET__DMD7YlP3__"